import { Button } from "@mui/material";
import { T } from "components/util/t";

export const PendingLeaderboardButton: React.FC<{onClick: () => void}> = ({ onClick }) => {
    return <Button variant='outlined' onClick={onClick}><T>View rankings</T></Button>;
};
